var indentation_default = {
  "indentZero": "JdZRL",
  "indentOne": "oLF7K",
  "indentTwo": "ReqGH",
  "indentThree": "FD4cf",
  "indentFour": "VIORa",
  "indentFive": "YhCqE",
  "indentSix": "uEsoo"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
